export default __webpack_public_path__ + "static/media/MyEvent_Billings.055c7ad5.svg";